<template>
  <div class="cc-options">
    <div class="cc-options__field">
      <label
        class="cc-label"
        for="cc-source-system"
      >{{ $t('convertCoordinates.sourceSystem') }}</label>
      <select
        id="cc-source-system"
        class="cc-input"
        :value="sourceSystem"
        :disabled="disabled"
        @change="$emit('update:sourceSystem', $event.target.value)"
      >
        <option
          v-for="item in systems"
          :key="item"
          :value="item"
        >
          {{ $t(`convertCoordinates.systems.${item}`) }}
        </option>
      </select>
    </div>
    <div class="cc-options__field">
      <label
        class="cc-label"
        for="cc-utm-zone"
      >{{ $t('convertCoordinates.defaultUtmZone') }}</label>
      <input
        id="cc-utm-zone"
        class="cc-input"
        type="text"
        :value="utmZone"
        :disabled="disabled"
        maxlength="8"
        :placeholder="$t('convertCoordinates.utmZonePlaceholder')"
        autocomplete="off"
        @input="$emit('update:utmZone', $event.target.value)"
      >
      <p class="cc-hint">
        {{ $t('convertCoordinates.defaultUtmZoneHint') }}
      </p>
    </div>
  </div>
</template>

<script>
import { SOURCE_SYSTEMS } from '@/api/coordinate-conversion/types'

export default {
  name: 'ConversionOptions',
  props: {
    sourceSystem: {
      type: String,
      default: 'auto',
    },
    utmZone: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      systems: SOURCE_SYSTEMS,
    }
  },
}
</script>
